export default __webpack_public_path__ + "static/media/kzt3.77934a75.jpg";